import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  toggleMenu() {
    $('#giveaways-admin-menu').toggle();
  }

}
